import { getSessionData } from 'root/apps/QuoteMachineIntegration/utils/SessionData';

import type { WebComponentCompatConfig } from './types';

/**
 * Maps R-Series session data into invoicing WC `init()` compat shims so
 * `InvoicingApp` can populate `SessionDataContext` (currency, permissions,
 * features) the same way single-spa parcels receive `sessionData`.
 */
export function getWebComponentCompatConfig(): WebComponentCompatConfig {
  const { currency, permissions, features, datadog } = getSessionData();

  return {
    compatCurrency: {
      currencyCode: currency.currencyCode,
      currencySymbol: currency.currencySymbol,
    },
    compatPermissions: {
      hasAdminRight: permissions.hasAdminRight,
      hasAutomatedAccountReceivablesRight: permissions.hasAutomatedAccountReceivablesRight,
    },
    compatFeatures: features,
    ...(datadog ? { compatDatadog: datadog } : {}),
  };
}
